module.exports = __webpack_public_path__ + "img/9.9050fd5e.png";